import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { MatDialogModule } from "@angular/material/dialog";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

import { AgentOfferComponent } from "./offer/agent-offer/agent-offer.component";
import { OutletSelectionComponent } from "./outlet-selection/outlet-selection.component";
import { AgentOfferIntroComponent } from "./offer/agent-offer-intro/agent-offer-intro.component";

@NgModule({
    imports: [
        FormsModule,
        CommonModule,
        MatDialogModule,
        AgentOfferComponent,
        OutletSelectionComponent,
        AgentOfferIntroComponent
    ],
    exports: [MatDialogModule],
    providers: [
        { provide: MatDialogRef, useValue: {} },
        { provide: MAT_DIALOG_DATA, useValue: [] }
    ]
})
export class OnboardingModule { }
